<template>
  <info-header-card
    :icon="instrument.icon()"
    :header="`Instrument ${instrument.name} details`"
    :rows="rows"
    class="animated fadeIn mt-3"
  />
</template>

<script>
import InstrumentModel from "@/models/lab/InstrumentModel"
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";

export default {
  name: "InstrumentCard",
  components: { InfoHeaderCard },
  props: {
    instrument: {
      type: Object,
      default: () => new InstrumentModel()
    }
  },
  computed: {
    rows() {
      return [
        {
          label: "Name",
          value: this.instrument.name
        },
        {
          label: "Abbrev",
          value: this.instrument.formatAbbrev()
        },
        {
          label: "Capacity",
          value: this.instrument.capacity
        },
        {
          label: "Daily Capacity",
          value: this.instrument.daily_capacity
        },
        {
          label: "Runtime",
          value: `${this.instrument.runtime} ${this.instrument.runtime_display}`
        },
        {
          label: "Description",
          value: this.instrument.description || "Not specified"
        }
      ];
    }
  }
};
</script>
